<template>
<el-card class="box-card bg-purple">
  <div class="clearfix" slot="header">Αναζήτηση Πανεπιστημίων
    <el-button style="float: right; padding: 3px 0;" type="text" @click="toggleUniSearch">
      Κλείσιμο
    </el-button>
  </div>
  <div class="text item">
    <el-form label-width='110px'>
      <el-form-item label="Χώρα">
        <el-select
          class="countries"
          v-model="selCountry"
          value-key="id"
          placeholder="Χώρα"
          filterable="filterable"
          clearable="clearable"
          @change="selectedCountryUpdated"
        >
          <el-option v-for="country in countries" :key="country.id" :label="country.name" :value="country">
          </el-option>
        </el-select>
      </el-form-item>
      <el-card v-if='showCountryDetails' hit shadow class="box-card bg-purple-light"
        v-loading="this.gettingCountryDetails">
        <el-form label-width='110px'>
          <el-row type="flex">
            <el-col>
              <el-form-item v-show="this.selCountryDetails!= ''" label="Ονομα" size="small">
                {{this.selCountryDetails.name}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item v-show="this.selCountryDetails!= ''" label="Προηγ. όνομα" size="small">
                {{this.selCountryDetails.ex_name}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item v-show="this.selCountryDetails!= ''" label="Συντομογραφία" size="small">
                {{this.selCountryDetails.short_name}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <br>
      <el-form-item label="Πανεπιστήμια">
        <el-select
          v-model="selUniversity"
          value-key="id"
          placeholder="Πανεπιστήμιο"
          class="big"
          filterable="filterable"
          clearable="clearable"
          @change="selectedUniversityUpdated"
          :disabled= 'disabledUni'
        >
          <el-option v-for="university in selCountryUniversities" :key="university.id"
            :label="university.name" :value="university">
          </el-option>
        </el-select>
      </el-form-item>
      <el-card v-if='showUniDetails' hit shadow class="box-card bg-purple-light" v-loading="this.gettingUniversityDetails">
        <el-form label-width='110px'>
          <el-form-item label="Όνομα" size="small">
            {{this.selUniversityDetails.name}}
          </el-form-item>
          <el-form-item label="Πρ. όνομα" size="small">
            {{this.selUniversityDetails.ex_name}}
          </el-form-item>
          <el-row type="flex">
            <el-col>
              <el-form-item label="Παν/μιο" size="small">
                {{translate (this.selUniversityDetails.university_type_status, 'university_type_status')}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Ενεργό" size="small">
                {{translate (this.selUniversityDetails.active, 'active')}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Τύπος" size="small">
                {{this.selUniversityDetails.type}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col>
              <el-form-item  label="Αναγνώριση" size="small">
                {{translate (this.selUniversityDetails.accredited, 'accredited')}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Αρ. Συνεδρίας" size="small">
                {{this.selUniversityDetails.meeting.meeting_no}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Αρ. Πράξης" size="small">
                {{this.selUniversityDetails.epitropi_id}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col>
              <el-form-item label="Διεύθυνση" size="small">
                {{this.selUniversityDetails.address}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Πόλη" size="small">
                {{this.selUniversityDetails.city.name}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Πολιτεία" size="small">
                {{this.selUniversityDetails.state.name}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col>
              <el-form-item label="Τηλέφωνο" size="small">
                {{this.selUniversityDetails.phone}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Τηλέφωνο 2" size="small">
                {{this.selUniversityDetails.other_phone}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Φαξ" size="small">
                {{this.selUniversityDetails.fax_no}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col>
              <el-form-item label="E-mail" size="small">
                {{this.selUniversityDetails.email}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Μη παν/κο ίδρυμα" size="small">
                {{this.selUniversityDetails.non_universities_type_id}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Για Διαδίκτυο" size="small">
                {{this.selUniversityDetails.h_internet}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="Σχόλια" size="small">
            {{this.selUniversityDetails.comments}}
          </el-form-item>
        </el-form>
      </el-card>
      <br>
      <el-form-item label="Κολλέγια">
        <el-select
          v-model="selCollege"
          value-key="id"
          placeholder="Κολλέγιο"
          class="big"
          filterable="filterable"
          clearable="clearable"
          @change="selectedCollegeUpdated"
          :disabled= 'disabledCol'
        >
          <el-option v-for="college in selUniColleges" :key="college.id" :label="college.name" :value="college"></el-option>
        </el-select>
      </el-form-item>
      <el-card v-if='showCollegeDetails' hit shadow class="box-card bg-purple-light" v-loading="this.gettingCollegeDetails">
        <el-form label-width='130px'>
          <el-form-item label="Όνομα" size="small">
            {{this.selCollegeDetails.name}}
          </el-form-item>
          <el-row type="flex">
            <el-col>
              <el-form-item label="Αναγνώριση" size="small">
                {{translate( this.selCollegeDetails.accredited, 'accredited')}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Αρ. Πράξης" size="small">
                {{this.selCollegeDetails.epitropi_id}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Αρ. Συνεδρίασης" size="small">
                {{this.selCollegeDetails.meeting.meeting_no}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="Ενεργό" size="small">
            {{translate (this.selCollegeDetails.active, 'active')}}
          </el-form-item>
          <el-form-item label="Σχόλια" size="small">
            {{this.selCollegeDetails.comments}}
          </el-form-item>
        </el-form>
      </el-card>
      <br>
      <el-form-item label="Σχολές">
        <el-select
          v-model="selFaculty"
          value-key="id"
          placeholder="Σχολή"
          class="big"
          filterable="filterable"
          clearable="clearable"
          @change="selectedFacultyUpdated"
          :disabled= 'disabledFac'
        >
          <el-option v-for="faculty in selUniColFaculties" :key="faculty.id" :label="faculty.name" :value="faculty"></el-option>
        </el-select>
      </el-form-item>
      <el-card v-if='showFacultyDetails' hit shadow class="box-card bg-purple-light" v-loading="this.gettingFacultyDetails">
        <el-form label-width='130px'>
          <el-form-item label="Όνομα Σχολής" size="small">
            {{this.selFacultyDetails.name}}
          </el-form-item>
          <el-row type="flex">
            <el-col>
              <el-form-item label="Αναγνώριση" size="small">
                {{translate (this.selFacultyDetails.accredited, 'accredited')}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Αρ. Πράξης" size="small">
                {{this.selFacultyDetails.epitropi_id}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Αρ. Συνεδρίασης" size="small">
                {{this.selFacultyDetails.meeting.meeting_no}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="Ενεργή" size="small">
            {{translate (this.selFacultyDetails.active, 'active')}}
          </el-form-item>
          <el-form-item label="Σχόλια" size="small">
            {{this.selFacultyDetails.comments}}
          </el-form-item>
        </el-form>
      </el-card>
      <br>
      <el-form-item label="Τμήματα">
        <el-select
          v-model="selDepartment"
          value-key="id"
          placeholder="Τμήμα"
          class="big"
          filterable="filterable"
          clearable="clearable"
          @change="selectedDepartmentUpdated"
          :disabled= 'disabledDept'
        >
          <el-option v-for="department in selUniColFacDepartments" :key="department.id" :label="department.name" :value="department"></el-option>
        </el-select>
      </el-form-item>
      <el-card v-if='showDepartmentDetails' hit shadow class="box-card bg-purple-light" v-loading="this.gettingDepartmentDetails">
        <el-form label-width='130px'>
          <el-form-item label="Όνομα" size="small">
            {{this.selDepartmentDetails.name}}
          </el-form-item>
          <el-row type="flex">
            <el-col>
              <el-form-item label="Αναγνώριση" size="small">
                {{translate (this.selDepartmentDetails.accredited, 'accredited')}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Πρόγραμμα/Σχολή" size="small">
                {{translate (this.selDepartmentDetails.programme, 'programme')}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Ενεργό" size="small">
                {{translate (this.selDepartmentDetails.active, 'active')}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col>
              <el-form-item label="Αρ. Πράξης" size="small">
                {{this.selDepartmentDetails.epitropi_id}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Αρ. Συνεδρίασης" size="small">
                {{this.selDepartmentDetails.meeting.meeting_no}}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="Σχόλια" size="small">
                {{this.selDepartmentDetails.comments}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </el-form>
  </div>
</el-card>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import config from '../../config.js'

export default {
  props: [],
  data () {
    return {
      disabledUni: true,
      disabledCol: true,
      disabledFac: true,
      disabledDept: true,
      showCountryDetails: false,
      showUniDetails: false,
      showCollegeDetails: false,
      showFacultyDetails: false,
      showDepartmentDetails: false,
      selCountry: '',
      selCountryDetails: {
        id: '',
        name: '',
        ex_name: '',
        short_name: ''
      },
      selUniversityDetails: {
        id: '',
        name: '',
        city: {
          id: '',
          name: ''
        },
        active: 'Y', // Y - Yes or N - No
        accredited: 'U', // R - accredited, N - not accredited, U - Under consideration
        meeting: {
          id: '',
          meeting_no: ''
        },
        comments: '',
        fax_no: '',
        other_phone: '',
        email: '',
        university_type_status: '',
        state: {
          id: '',
          name: ''
        },
        epitropi_id: '',
        address: '',
        phone: '',
        non_universities_type_id: '',
        h_internet: '',
        type: '',
        ex_name: ''
      },
      selCollegeDetails: {
        id: '',
        name: '',
        meeting: {
          id: '',
          meeting_no: ''
        },
        accredited: 'U', // R - accredited, N - not accredited, U - Under consideration
        active: 'Y', // Y - Yes or N - No
        comments: '',
        epitropi_id: ''
      },
      selUniversity: '',
      selCollege: '',
      selFaculty: '',
      selFacultyDetails: {
        id: '',
        name: '',
        active: 'Y', // Y - Yes or N - No
        comments: '',
        epitropi_id: '',
        accredited: 'U', // R - accredited, N - not accredited, U - Under consideration
        meeting: {
          id: '',
          meeting_no: ''
        }
      },
      selDepartment: '',
      selDepartmentDetails: {
        id: '',
        academic_areas_id: '',
        name: '',
        programme: '', // P - Πρόγραμμα or D - Σχολή
        active: 'Y', // Y - Yes or N - No
        comments: '',
        epitropi_id: '',
        accredited: 'U', // R - accredited, N - not accredited, U - Under consideration
        meeting: {
          id: '',
          meeting_no: ''
        }
      },
      selCountryUniversities: [],
      selUniColleges: [],
      selUniColFaculties: [],
      selUniColFacDepartments: [],
      gettingCountryDetails: false,
      gettingUniversityDetails: false,
      gettingCollegeDetails: false,
      gettingFacultyDetails: false,
      gettingDepartmentDetails: false
    }
  },
  methods: {
    translate (term, category) {
      switch (category) {
        case 'active':
          if (term === 'Y') {
            return 'Ναι'
          } else return 'Όχι'
        case 'accredited':
          if (term === 'R') {
            return 'Αναγνωρισμένο'
          } else if (term === 'N') {
            return 'Μη αναγνωρισμένο'
          } else if (term === 'U') {
            return 'Μη κριθέν'
          }
          break
        case 'programme':
          if (term === 'P') {
            return 'Πρόγραμμα'
          } else if (term === 'D') {
            return 'Σχολή'
          }
          break
        case 'university_type_status':
          if (term === 'Y') {
            return 'Ναι'
          } else if (term === 'N') {
            return 'Άλλο Ίδρυμα'
          } else if (term === 'E') {
            return 'Επιτροπή'
          }
          break
      }
    },
    toggleUniSearch () {
      this.$store.dispatch('SHOW_HIDE_UNISEARCH')
    },
    // country selected from menu
    selectedCountryUpdated () {
      this.showCountryDetails = false
      this.showUniDetails = false
      this.showCollegeDetails = false
      this.showFacultyDetails = false
      this.showDepartmentDetails = false
      this.selUniversity = ''
      this.selCollege = ''
      this.selFaculty = ''
      this.selDepartment = ''
      this.disabledUni = false
      this.disabledCol = true
      this.disabledFac = true
      this.disabledDept = true
      if (this.selCountry) {
        axios.get(`${config.BASE_URL}/countries/${this.selCountry.id}/universities`)
          .then((response) => {
            this.selCountryUniversities = response.data.data
          }, (err) => {
            this.backendError(err)
          })
        // fetch details of the selected country
        this.gettingCountryDetails = true
        axios.get(`${config.BASE_URL}/admins/userid/countries/${this.selCountry.id}`)
          .then((response) => {
            this.gettingCountryDetails = false
            this.showCountryDetails = true
            this.selCountryDetails = response.data.data
          }).catch(err => {
            this.backendError(err)
          })
      }
    },
    // university selected from the menu
    selectedUniversityUpdated () {
      this.showUniDetails = false
      this.showCollegeDetails = false
      this.showFacultyDetails = false
      this.showDepartmentDetails = false
      this.selCollege = ''
      this.selFaculty = ''
      this.selDepartment = ''
      this.disabledCol = false
      this.disabledFac = true
      this.disabledDept = true
      if (this.selUniversity) {
        axios.get(`${config.BASE_URL}/countries/${this.selCountry.id}/universities/${this.selUniversity.id}`)
          .then((response) => {
            this.selUniColleges = response.data.data.colleges
          }, (err) => {
            this.backendError(err)
          })
        // fetch details of the selected university
        this.gettingUniversityDetails = true
        axios.get(`${config.BASE_URL}/universities/${this.selUniversity.id}`)
          .then((response) => {
            this.selUniversityDetails = response.data.data[0]
            this.showUniDetails = true
            this.gettingUniversityDetails = false
          }).catch(err => {
            this.backendError(err)
          })
      }
    },
    // college selected from menu
    selectedCollegeUpdated () {
      this.showCollegeDetails = false
      this.showFacultyDetails = false
      this.showDepartmentDetails = false
      this.selFaculty = ''
      this.selDepartment = ''
      this.selUniColFaculties = this.selCollege.faculties
      this.disabledFac = false
      this.disabledDept = true
      // fetch details of the selected college
      this.gettingCollegeDetails = true
      if (this.selCollege) {
        axios.get(`${config.BASE_URL}/colleges/${this.selCollege.id}`)
          .then((response) => {
            this.selCollegeDetails = response.data.data[0]
            this.showCollegeDetails = true
            this.gettingCollegeDetails = false
          }).catch(err => {
            this.backendError(err)
          })
      }
    },
    // faculty selected from menu
    selectedFacultyUpdated () {
      this.showFacultyDetails = false
      this.showDepartmentDetails = false
      this.selDepartment = ''
      this.selUniColFacDepartments = this.selFaculty.departments
      this.disabledDept = false
      // fetch details of the selected faculty
      this.gettingFacultyDetails = true
      if (this.selFaculty) {
        axios.get(`${config.BASE_URL}/faculties/${this.selFaculty.id}`)
          .then((response) => {
            this.selFacultyDetails = response.data.data[0]
            this.showFacultyDetails = true
            this.gettingFacultyDetails = false
          }).catch(err => {
            this.backendError(err)
          })
      }
    },
    // department selected from menu
    selectedDepartmentUpdated () {
      this.showDepartmentDetails = false
      // fetch details of the selected department
      this.gettingDepartmentDetails = true
      if (this.selDepartment) {
        axios.get(`${config.BASE_URL}/departments/${this.selDepartment.id}`)
          .then((response) => {
            this.selDepartmentDetails = response.data.data[0]
            this.showDepartmentDetails = true
            this.gettingDepartmentDetails = false
          }).catch(err => {
            this.backendError(err)
          })
      }
    }
  },
  computed: {
    ...mapGetters(['activeRole', 'currentUser']),
    ...mapState([
      'searchedApps',
      'workingApplication',
      'showSearchedApplication',
      'searchedApplication',
      'loadingSearchedApplication',
      'loadingSearchedApplications',
      'searchedAppHistory',
      'BASE_URL',
      'countries',
      'presidentDecisions'
    ])
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
.el-select {
    &.big {
      width: 440px;
    }
    &.biggest {
      width: 1100px;
    }
    &.countries {
      width: 440px;
    }
  }
  .searchButton {
    margin-left: 30px
  }
  .el-input {
    width: 200px
  }
  .bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  // border-radius: 10px;
  // border-style: solid;
  // border-color: #7fa3bb green #86b8da yellow;
  // border-width: 0px 0px 2px 0px;
  // border: 2px 0px 0px 0px solid #7fa3bb;
  padding-right: 20px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SearchUni.vue